<template>
  <div>
    <Header />

    <h2>Sorry, we can't find what you're looking for!</h2>

    <hr />

    <EmailCollection />

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import EmailCollection from '@/components/layout/EmailCollection';

export default {
  name: 'NotFound',
  components: {
    Header,
    Footer,
    EmailCollection
  }
}
</script>

<style scoped>
</style>